import Service from '../Service';
import AuthService from '../AuthService';

const Species = {
  getAllSpecies() {
    return AuthService.get(`species`);
  },
  getSpecies() {
    return AuthService.get(`settings/spp`);
  },
  getCategory() {
    return AuthService.get(`category`);
  },
  createSpecies(data, token) {
    return AuthService.post(`settings/spp?token=${token}`, data);
  },
  updateSpecies(payload, id, token) {
    return AuthService.put(`settings/spp/${id}?token=${token}`, payload);
  },
  deleteSpecies(id, token) {
    return AuthService.delete(`settings/spp/${id}?token=${token}`);
  }
};

export default Species;
